<script lang="ts" setup>
import { useRouter } from 'vue-router';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

const router = useRouter();

const goToDashboard = () => {
  router.push('/');
};
</script>

<template>
  <div class="unauthorized">
    <Card>
      <template #title>
        <h1 class="unauthorized-title">
          <FontAwesomeIcon icon="exclamation-triangle" class="unauthorized-icon" />
          <br>
          Unauthorized
        </h1>
      </template>
      <template #content>
        <div class="justify-content-center text-center">
          <p class="unauthorized-message">You do not have permission to access this page.</p>
        <p class="unauthorized-message">If you believe this is an error, please reach out to us at: airin@tuev-lab.ai.</p>
        <Button label="Go back to the Dashboard" class="p-button-tuev" @click="goToDashboard">
          <template #icon>
            <FontAwesomeIcon icon="arrow-left" />
          </template>
        </Button> 
        </div>

      </template>
    </Card>
  </div>
</template>

<style scoped>
.unauthorized {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.unauthorized .p-card {
  width: 100%;
  max-width: 500px;
  padding: 20px;
  text-align: center;
  margin: 20px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  color: #333;
  font-size: 1.2em;
  font-weight: 400;
  line-height: 1.5;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s;
}
.unauthorized-title {
  font-size: 2em;
  color: red;
  margin: 0;
  text-align: center;
  font-weight: bold;
}

.unauthorized-message {
  margin: 20px 0;
  text-align: center;
}
</style>
